import Styled from 'styled-components';

import { IModalContent, modalContentStyles } from './common';

export const ModalContent = Styled.div<IModalContent>`
  ${modalContentStyles}
`;

ModalContent.displayName = 'ModalContent';
